import { render } from "./JobsEmail.vue?vue&type=template&id=68562dcc"
import script from "./JobsEmail.vue?vue&type=script&lang=js"
export * from "./JobsEmail.vue?vue&type=script&lang=js"
script.render = render

export default script